<template>
  <div class="content-container">
    <a-form-model
      ref="searchForm"
      class="search-form"
      layout="horizontal"
      :model="searchParam"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 16 }"
      style="padding: 25px"
    >
      <a-row type="flex" align="middle">
        <a-col :span="6">
          <a-form-model-item
            has-feedback
            :label="$t('form.tag.name.label')"
            prop="name"
            style="margin-bottom: 0px"
          >
            <a-input v-model="searchParam.name" :placeholder="$t('form.tag.name.placeholder')" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item
            has-feedback
            :label="$t('form.tag.type.label')"
            style="margin-bottom: 0px"
          >
            <a-select
              mode="multiple"
              :placeholder="$t('form.tag.type.placeholder')"
              v-model="searchParam.type"
              :allowClear="true"
            >
              <a-select-option value="0">{{
                $t("enum.tagType.0")
              }}</a-select-option>
              <a-select-option value="1">{{
                $t("enum.tagType.1")
              }}</a-select-option>
              <a-select-option value="2">{{
                $t("enum.tagType.2")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-row type="flex" justify="space-between" align="middle">
            <a-col>
              <a-button type="primary" html-type="submit" @click="search">{{
                $t(`actionTitles.submit`)
              }}</a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
                $t(`actionTitles.clear`)
              }}</a-button>
            </a-col>
            <a-col>
              <a-button
                type="primary"
                :style="{ margin: '0px 15px' }"
                @click="addTag"
                >{{$t('actionTitles.add')}}</a-button
              >
              <!-- <a-dropdown placement="bottomLeft">
                <a-menu slot="overlay" @click="handleChangeOperate" style="width: 120px">
                  <a-menu-item key="delete">{{$t('message.delete')}}</a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px">
                  {{$t('message.moreOperate')}}
                  <a-icon type="down" />
                </a-button>
              </a-dropdown>-->
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form-model>

    <div class="table-wrapper">
      <!-- <clear-selected
        alert-type="info"
        :show="selectedRowKeys.length>0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />-->

      <a-table
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column key="id" :title="$t('table.tag.thead.tagId')" data-index="id" align="center">
          <template slot-scope="text, record">
            <span>{{ record.id }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="type"
          :title="$t('table.tag.thead.cate')"
          data-index="type"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ $t(`enum.tagType.${record.type}`) }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="name"
          :title="$t('table.tag.thead.name')"
          data-index="name"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.name }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="sort_order"
          :title="$t('table.common.thead.sort')"
          data-index="sort_order"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.sort_order }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="edit(record)">{{$t('actionTitles.edit')}}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => del(record.id)"
              >
                <a href="javascript:;" style="color: red">{{
                  $t(`actionTitles.delete`)
                }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="modelTitle"
      :visible="isShowTagModel"
      @ok="confirmAddTag"
      @cancel="cancelAddTag"
      keyboard
    >
      <a-form-model
        ref="tagModel"
        :model="newTagForm"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item ref="name" :label="$t('form.tag.name.label')" prop="name">
          <a-input
            v-model="newTagForm.name"
            :placeholder="$t('form.tag.name.placeholder')"
            @blur="
              () => {
                $refs.name.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('form.tag.type.label')" ref="type" prop="type">
          <a-select
            :placeholder="$t('form.tag.type.placeholder')"
            @change="handleChangeSelect"
            :value="
              typeof newTagForm.type === 'number' ? newTagForm.type : undefined
            "
            :allowClear="true"
          >
            <a-select-option
              :value="item.value"
              v-for="item in selectOptions"
              :key="item.id"
              :disabled="item.disabled"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="sort_order" :label="$t('table.common.thead.sort')" prop="sort_order">
             <a-input-number  v-model="newTagForm.sort_order" :min="0"    :placeholder="$t('message.sortTip')" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { getTagList, delTag, addTagOrUpdateTag } from "@/api/tag";

export default {
  data() {
    return {
      searchParam: {
        current_page: 1,
        per_page: 10,
        name: "",
        uid: 0,
        order: {},
        type: [], //0全景圖片 1全景視頻 2全景直播
      },
      data: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      isShowTagModel: false,
      modelTitle: "",
      newTagForm: {
        id: null,
        uid: 0,
        type: undefined,
        name: "",
        sort_order: 99,
      },
      selectOptions: [
        { id: 0, value: 0, title: this.$t("enum.tagType.0"), disabled: false },
        { id: 1, value: 1, title: this.$t("enum.tagType.1"), disabled: false },
        { id: 2, value: 2, title: this.$t("enum.tagType.2"), disabled: false },
      ],
      rules: {
        name: [
          {
            required: true,
            message: this.$t('form.tag.name.message'),
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: this.$t('form.tag.type.message'), trigger: "change" },
        ],
      },
    };
  },
  components: { ClearSelected },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      getTagList(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.data = res.data.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.pagination.current=1;
      this.searchParam = { status: [] };
      this.loadData();
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      // if (Object.keys(filters).length > 0) {
      //   this.searchParam.status = filters.status;
      // }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchParam.order = order;
      }
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleReset() {
      this.searchParam = { ...this.searchParam, name: "", type: [] };
      this.loadData();
    },
    handleChangeSelect(value) {
      this.newTagForm.type = value;
    },
    handleChangeOperate(e) {},
    addTag() {
      this.modelTitle = this.$t('form.tag.title.add');
      this.isShowTagModel = true;
    },
    confirmAddTag() {
      this.$refs.tagModel.validate((valid) => {
        if (valid) {
          addTagOrUpdateTag(this.newTagForm)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success(this.$t("message.saveSuccess"), 2, () => {
                  this.isShowTagModel = false;
                  this.modelTitle = "";
                  this.$refs.tagModel.resetFields();
                  this.newTagForm = {
                    id: null,
                    uid: 0,
                    type: undefined,
                    name: "",
                    sort_order: 99,
                  };
                  this.loadData();
                });
              }
            })
            .catch((err) => {});
        }
      });
    },
    cancelAddTag() {
      this.isShowTagModel = false;
      this.modelTitle = "";
      this.$refs.tagModel.resetFields();
      this.newTagForm = {
        id: null,
        uid: this.$store.getters.userInfo.id,
        type: undefined,
        name: "",
        sort_order: 99,
      };
    },
    edit(item) {
      this.newTagForm = {
        ...this.newTagForm,
        id: item.id,
        name: item.name,
        sort_order: item.sort_order,
        type: item.type,
      };
      console.log(this.newTagForm);
      this.modelTitle = this.$t('form.tag.title.modify');
      this.isShowTagModel = true;
    },
    del(id) {
      delTag({ id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
              if (this.selectedRowKeys.length) {
                this.selectedRowKeys = [];
                this.selectedRows = [];
              }
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="less" scoped>
.ant-input-number{
  width: 100%;
}
</style>
